<template>
  <div class="page-sidebar navbar-collapse collapse myposition">
    <ul class="page-sidebar-menu page-sidebar-menu-hover-submenu " data-keep-expanded="false"
        data-auto-scroll="true" data-slide-speed="200">

      <li v-for ="item in menu" :class="{'active': item.active.indexOf(route)!==-1}" v-bind:key="item.name">
        <router-link :to="{ name: item.name }">
          <i :class="item.icon"></i>
          <span class="title">{{item.title}}</span>
          <span :class="{'selected': item.active.indexOf(route)!==-1}"></span>
        </router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import store from '../../store'

export default {
  watch: {
    '$route' (to, from) {
      this.route = this.$route.name
    }
  },
  methods: {
    logout () {
      this.$store.dispatch('logout')
    }
  },
  data () {
    return {
      user: store.getters.currentUser,
      route: this.$route.name,
      current: null,
      active: null,
      menu: [
        {
          name: 'home',
          title: 'Home',
          icon: 'icon-home',
          active: ['home']
        },
        {
          name: 'profile',
          title: 'Profile',
          icon: 'icon-user',
          active: ['profile']
        },
        {
          name: 'projects',
          title: 'Projects',
          icon: 'icon-flag',
          active: ['projects', 'projects.edit', 'projects.create']
        },
        {
          name: 'contributions-management',
          title: 'Contributions',
          icon: 'icon-contributions',
          active: ['contributions-management']
        },
        {
          name: 'project-updates-list',
          title: 'Project Update',
          icon: 'icon-custom-projects',
          active: ['project-updates-list']
        },
        /* {
          name: 'contributions',
          title: 'Contributions',
          icon: 'fa fa-money',
          active: ['contributions']
        },
        {
          name: 'updates',
          title: 'Updates',
          icon: 'icon-feed',
          active: ['updates']
        }, */
        {
          name: 'resources',
          title: 'Resources',
          icon: 'icon-picture',
          active: ['resources']
        }
      ]
    }
  }

}
</script>

<style scoped>
  @media(min-width: 992px){
    .page-sidebar {
      width: 85px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/partner/Side.vue